require('../../modules/es7.symbol.async-iterator');
module.exports = require('../../modules/_wks-ext').f('asyncIterator');



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/fn/symbol/async-iterator.js